import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Configuration } from '@app/common/configuration';
import { UserLoginInfo } from '@app/apiModules/userLoginInfo';
import { apiResponseFormat } from '@app/common/variables';

@Injectable({
    providedIn: 'root'
})
export class LoginService {
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    authServerUrl = environment.API_APP_PATH;

    constructor(private readonly http: HttpClient) {

    }
    public authenticate(
        userLoginInfoDto: UserLoginInfo,
        observe?: 'body',
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<any>;
    public authenticate(
        userLoginInfoDto: UserLoginInfo,
        observe?: 'response',
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<HttpResponse<any>>;
    public authenticate(
        userLoginInfoDto: UserLoginInfo,
        observe?: 'events',
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<HttpEvent<any>>;
    public authenticate(
        userLoginInfoDto: UserLoginInfo,
        observe: any = 'body',
        reportProgress = false,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<any> {
        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json',
            ];
            httpHeaderAcceptSelected =
                this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if (
            httpHeaderAcceptSelected?.startsWith('text')
        ) {
            responseType = 'text';
        }

        return this.http.post<any>(
            `${this.authServerUrl}/api/app/authenticate/login`,
            userLoginInfoDto,
            {
                responseType: responseType as any,
                withCredentials: false,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }
   
    public apiUserLogoutPost(observe?: 'body', reportProgress?: boolean, options?: { httpHeaderAccept?: apiResponseFormat }): Observable<any>;
    public apiUserLogoutPost(observe?: 'response', reportProgress?: boolean, options?: { httpHeaderAccept?: apiResponseFormat }): Observable<HttpResponse<any>>;
    public apiUserLogoutPost(observe?: 'events', reportProgress?: boolean, options?: { httpHeaderAccept?: apiResponseFormat }): Observable<HttpEvent<any>>;
    public apiUserLogoutPost(observe: any = 'body', reportProgress: boolean = false, options?: { httpHeaderAccept?: apiResponseFormat }): Observable<any> {

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if (httpHeaderAcceptSelected?.startsWith('text')) {
            responseType = 'text';
        }

        return this.http.post<any>(`${this.authServerUrl}/api/app/authenticate/log-out`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }
}
